import * as TabsPrimitive from '@radix-ui/react-tabs';

export { TabsContent } from '@/components/ui/tabs-content';
export { TabsList } from '@/components/ui/tabs-list';
export { TabsTrigger } from '@/components/ui/tabs-trigger';

const Tabs = TabsPrimitive.Root;

export { Tabs };
